import { render, staticRenderFns } from "./TakeVideo.vue?vue&type=template&id=dac07fea&scoped=true&"
import script from "./TakeVideo.vue?vue&type=script&lang=js&"
export * from "./TakeVideo.vue?vue&type=script&lang=js&"
import style0 from "./TakeVideo.vue?vue&type=style&index=0&id=dac07fea&scoped=true&lang=css&"
import style1 from "./TakeVideo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac07fea",
  null
  
)

export default component.exports